// The Compensation card on the requisition (DS Q-13, DC-28/72): BRD chapter 6's rows in his order, each drawn only when
// the server's field policy sent its key — "Restricted fields must also be absent from search, exports, reports, email,
// attachments, audit summaries and APIs." The Hiring Manager therefore sees the recommended hiring range and the
// proposed package, never the internal equity notes, and the card carries the Limited tag: the projection decides,
// never a hidden field. While the Compensation review is Pending or In Review the value cells show only its status
// ("Compensation alone finalizes official recommendation/range."), never a placeholder figure.

import type { ReactNode } from "react";
import type { RequisitionFull } from "@/api/tools";
import { Card, KeyValue, Paragraph, Pill, TAG_LABELS, Tag, TextLink, type KeyValueItem } from "@/mc";
import { COMP_WORD, range } from "./data";
import { COMP_ROW_LABELS, REQ_LABELS, REQ_RULES } from "./labels";

export function CompensationCard({ r, worksheetHref }: { r: RequisitionFull; worksheetHref?: string | undefined }) {
  const status = r.compensation_review_status ?? null;
  const word = status ? COMP_WORD[status] : undefined;
  const open = status !== null && status !== "finalized";
  const value = (shown: ReactNode): ReactNode => (open && word ? <Pill>{word}</Pill> : shown);
  const items: KeyValueItem[] = [];
  if ("comp_min" in r || "comp_max" in r) items.push([COMP_ROW_LABELS.recommendation, value(range(r.comp_min, r.comp_max, r.currency))]);
  if ("bonus_structure" in r) items.push([COMP_ROW_LABELS.proposedBase, value(r.bonus_structure || "—")]);
  if ("comp_approval_notes" in r) items.push([COMP_ROW_LABELS.internalEquity, value(r.comp_approval_notes || "—")]);
  const limited = !("comp_approval_notes" in r);
  return (
    <Card
      title={REQ_LABELS.compensationReview}
      pills={<>{word ? <Pill>{word}</Pill> : null}{limited ? <Tag tone="limited">{TAG_LABELS.limited}</Tag> : null}</>}
      actions={worksheetHref ? <TextLink href={worksheetHref} >{REQ_LABELS.compensationReview}</TextLink> : undefined}
      
    >
      <KeyValue rows items={items} />
      {open ? <Paragraph sm>{REQ_RULES.compensationAlone}</Paragraph> : null}
    </Card>
  );
}
